import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import AccessLevelsAPI from '../../api/accessLevels';

const state = {
  records: [],
  capabilities: [],
  uiFlags: {
    isFetching: false,
    isFetchingCapabilities: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getAccessLevels: $state => $state.records,
  getCapabilities: $state => $state.capabilities,
  getUIFlags: $state => $state.uiFlags,
  getAccessLevelById: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
};

const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isFetching: true });
    try {
      const response = await AccessLevelsAPI.get();
      commit(types.default.SET_ACCESS_LEVELS, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isFetching: false });
    }
  },

  getCapabilities: async ({ commit }) => {
    commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, {
      isFetchingCapabilities: true,
    });
    try {
      const response = await AccessLevelsAPI.getCapabilities();
      commit(
        types.default.SET_ACCESS_LEVEL_CAPABILITIES,
        response.data.capabilities
      );
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, {
        isFetchingCapabilities: false,
      });
    }
  },

  create: async ({ commit }, accessLevelObj) => {
    commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isCreating: true });
    try {
      const response = await AccessLevelsAPI.create(accessLevelObj);
      commit(types.default.ADD_ACCESS_LEVEL, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...accessLevelObj }) => {
    commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isUpdating: true });
    try {
      const response = await AccessLevelsAPI.update(id, accessLevelObj);
      commit(types.default.EDIT_ACCESS_LEVEL, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isDeleting: true });
    try {
      await AccessLevelsAPI.delete(id);
      commit(types.default.DELETE_ACCESS_LEVEL, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_ACCESS_LEVEL_UI_FLAG, { isDeleting: false });
    }
  },
};

const mutations = {
  [types.default.SET_ACCESS_LEVEL_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_ACCESS_LEVELS]: MutationHelpers.set,
  [types.default.SET_ACCESS_LEVEL_CAPABILITIES]($state, data) {
    $state.capabilities = data;
  },
  [types.default.ADD_ACCESS_LEVEL]: MutationHelpers.create,
  [types.default.EDIT_ACCESS_LEVEL]: MutationHelpers.update,
  [types.default.DELETE_ACCESS_LEVEL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
